import React from 'react';
import { useVenue } from '../../context/VenueContext';
import { Globe, MapPin } from 'lucide-react';

/**
 * ScopeSelector — dropdown to choose "brand" (all venues) or a specific venue.
 * Used in coupon, challenge, event, broadcast forms.
 * Props: value (scope string), onChange (callback), disabled
 */
export default function ScopeSelector({ value = 'brand', onChange, disabled = false }) {
  const { venues, isMultiVenue, activeVenue } = useVenue();

  if (!isMultiVenue) return null; // Single venue — no need to show selector

  const options = [
    { value: 'brand', label: 'Tutti i punti vendita', icon: Globe, color: '#3B82F6' },
    ...venues.map(v => ({
      value: `venue:${v.id}`,
      label: v.name,
      icon: MapPin,
      color: '#D44E20',
      address: v.address?.full,
    })),
  ];

  const current = options.find(o => o.value === value) || options[0];

  return (
    <div data-testid="scope-selector">
      <label className="block text-xs font-medium text-[#1A1A1A] mb-1.5">Punto vendita</label>
      <div className="relative">
        <select
          value={value}
          onChange={e => onChange(e.target.value)}
          disabled={disabled}
          data-testid="scope-select"
          className="w-full appearance-none px-3 py-2.5 pl-9 rounded-xl border border-slate-200 text-sm bg-white focus:outline-none focus:ring-2 focus:ring-[#D44E20]/20 focus:border-[#D44E20] transition-all disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {options.map(o => (
            <option key={o.value} value={o.value}>
              {o.value === 'brand' ? 'Tutti i punti vendita' : o.label}
            </option>
          ))}
        </select>
        <div className="absolute left-3 top-1/2 -translate-y-1/2 pointer-events-none">
          {current.value === 'brand'
            ? <Globe size={14} className="text-[#3B82F6]" />
            : <MapPin size={14} className="text-[#D44E20]" />
          }
        </div>
      </div>
      <p className="text-[10px] text-[#94A3B8] mt-1">
        {current.value === 'brand'
          ? 'Visibile in tutti i punti vendita del brand'
          : `Visibile solo in: ${current.label}`
        }
      </p>
    </div>
  );
}
